/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var People1Icon20Solid = forwardRef('People1Icon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M10 10.335A4.167 4.167 0 1 0 10 2a4.167 4.167 0 0 0 0 8.335Z" }),
        React.createElement("path", { d: "M2.661 16.367C3.543 12.29 7.786 12 10 12c2.214 0 6.457.29 7.339 4.367.191.886-.572 1.633-1.478 1.633H4.139c-.906 0-1.67-.747-1.478-1.633Z" })));
});
